const DEFAULT_MOBILE_APP_SETTINGS = {
  messages: true,
  attendance: true,
  biometric: true,
  lectures: true,
  syllabus: true,
  tests: true,
  marks: true,
  fees: true,
  remarks: true,
  performance: true,
  comparative: true,
  subject: true,
  logoUrl: '',
  appValidTill: '2027-12-31',
  notificationBalance: 24500,
  isExpired: false,
}

function getStoredSettings() {
  try {
    const raw = localStorage.getItem('cloud_mobile_app_settings')
    if (!raw) {
      localStorage.setItem('cloud_mobile_app_settings', JSON.stringify(DEFAULT_MOBILE_APP_SETTINGS))
      return DEFAULT_MOBILE_APP_SETTINGS
    }
    return { ...DEFAULT_MOBILE_APP_SETTINGS, ...JSON.parse(raw) }
  } catch {
    return DEFAULT_MOBILE_APP_SETTINGS
  }
}

function saveStoredSettings(data) {
  try {
    localStorage.setItem('cloud_mobile_app_settings', JSON.stringify(data))
    window.dispatchEvent(new Event('cloud-mobile-app-updated'))
  } catch (e) {
    console.error('Failed to save mobile app settings to localStorage', e)
  }
}

export async function fetchMobileAppSettings() {
  await new Promise((resolve) => setTimeout(resolve, 80))
  return getStoredSettings()
}

export async function saveMobileAppSettings(payload) {
  await new Promise((resolve) => setTimeout(resolve, 120))
  const current = getStoredSettings()
  const updated = {
    ...current,
    ...payload,
    updatedAt: new Date().toISOString(),
  }
  saveStoredSettings(updated)
  return updated
}

export async function resetMobileAppSettings() {
  await new Promise((resolve) => setTimeout(resolve, 100))
  saveStoredSettings(DEFAULT_MOBILE_APP_SETTINGS)
  return DEFAULT_MOBILE_APP_SETTINGS
}
